<template>
  <div class="custom-radio-large vx-row">
    <div
        v-for="(checkboxData, index) in data"
        :key="index"
        class="vx-col w-full sm:w-1/2 lg:w-1/3 pt-4 md:pt-0 mx-auto lg:mx-0">
      <checkbox-large
          v-model="localValues[index]"
          :vs-value="checkboxData.value"
          @changed="onChange($event, index)"
      >
        <div class="label">{{ checkboxData.label }}</div>
        <div class="body">{{ checkboxData.text }}</div>
      </checkbox-large>
    </div>
  </div>
</template>

<script>

import CheckboxLarge from '../../components/custom-form-fields/CheckboxLarge';

export default {
  name: "custom-radio-large",
  components: {
    CheckboxLarge
  },
  props: {
    value: {
      required: true
    },
    data: {
      type: Array,
      required: true
    },
  },
  data() {
    return {
      localValue: null,
      localValues: [],
    }
  },
  methods: {
    onChange(value, index) {
      this.localValues = [];

      if (!value || Array.isArray(value)) {
        return this.$emit('input', null);
      }

      this.localValues[index] = [value];
      this.$emit('input', value);
    },
  },
  watch: {
    value (val) {
      this.localValue = val;
    },
  },
}
</script>

<style lang="scss">
.custom-radio-large {
  > div.vx-col {
    line-height: 1;

    .label {
      font-size: 18px;
      padding-bottom: 0.5rem;
    }
  }
}
</style>
